<template>
  <section class="containerNotificationList">
    <span class="containerNotificationList__title">{{title}}</span>
      <div class="containerNotificationList__item"
        :class="{'unRead': !item.isRead, 'notUrl': !item.url}"
        v-for="(item, index) in notifications" :key="index"
        @click="redirectAction(item)">
        <div class="containerNotificationList__item--unRead">
          <span class="unReadDot" v-if="!item.isRead">·</span>
        </div>
        <div class="containerNotificationList__item--content">
          <span class="header" style="-webkit-box-orient: vertical;" :title="item.header">{{item.header}}</span>
          <span class="title" v-if="item.title" style="-webkit-box-orient: vertical;">{{item.title}}</span>
          <span class="subTitle" v-if="item.subtitle" style="-webkit-box-orient: vertical;">{{item.subtitle}}</span>
          <span class="timeAgo">{{item.formattedTimeAgo}}</span>
        </div>
        <span class="containerNotificationList__item--icon icon-grey-ellipsis"
          @click="openOptions($event, index)">
        </span>
        <optionsNotificationComponent
          v-if="optionsOpen && index === selectedIndex"
          v-click-away="closeOptions"
          :notification="item"
          :options="optionsNotification"
          @markAsRead="markAsRead"
          @removeNotification="removeNotification"
        >
        </optionsNotificationComponent>
      </div>
  </section>
</template>

<script>
import optionsNotificationComponent from '../optionsNotification/optionsNotification'
import messages from '../../messages.json'
import { markAsReadService, removeNotificationService } from '../../services'
import { onMounted, ref, computed } from 'vue'

export default {
  name: 'notificationList',
  props: {
    notifications: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  components: {
    optionsNotificationComponent
  },
  emits: ['close-notifications-menu', 'open-options', 'splice-notifications'],
  setup (props, { emit }) {
    const selectedIndex = ref(null)
    const optionsNotification = ref([])
    const optionsOpen = ref(false)

    onMounted(() => {
      optionsNotification.value = messages.optionsNotification.specific
    })

    const notifications = computed(() => {
      return props.notifications
    })

    /**
     * @description Go page of the notification
     * @param notification notification item
     */
    function redirectAction (notification) {
      if (!notification.isRead) {
        markAsReadService(notification.id).then(
          (response) => {
            emit('close-notifications-menu')
            if (notification.url) window.open(notification.url, '_self')
          },
          (error) => {
            console.error(error)
          }
        )
      } else {
        emit('close-notifications-menu')
        if (notification.url) window.open(notification.url, '_self')
      }
    }

    /**
     * @description Open options menu
     * @param event DOM event
     * @param index index of notification
     */
    function openOptions (event, index) {
      event.preventDefault()
      event.stopPropagation()
      if (optionsOpen.value && index === selectedIndex.value) {
        closeOptions()
      } else {
        optionsOpen.value = true
        selectedIndex.value = index
        emit('open-options')
      }
    }

    /**
     * @description Close options menu
     */
    function closeOptions () {
      optionsOpen.value = false
      selectedIndex.value = null
    }

    /**
     * @description Mark notification as read
     * @param notification notification object
     */
    function markAsRead (notification) {
      markAsReadService(notification.id).then(
        (response) => {
          notification.isRead = response.data.success
          closeOptions()
        },
        (error) => {
          console.error(error)
        }
      )
    }

    /**
     * @description Remove notification
     * @param notification notification object
     */
    function removeNotification (notification) {
      removeNotificationService(notification.id).then(
        (response) => {
          let config = {
            'title': props.title,
            'index': selectedIndex.value,
            'number': 1
          }
          emit('splice-notifications', config)
          closeOptions()
        },
        (error) => {
          console.error(error)
        }
      )
    }

    return {
      removeNotification,
      redirectAction,
      openOptions,
      markAsRead,
      selectedIndex,
      optionsNotification,
      optionsOpen,
      closeOptions,
      notifications
    }
  }
}
</script>
